import {ThreeCorpus} from '../ThreeCorpus';
import {CylinderGeometry, Group, Mesh, Object3D, Vector3} from 'three';
import {
    ISaveBarCounterCorpusData
} from '../../../../../../../common-code/interfaces/saveData/ISaveBarCounterCorpusData';
import {
    ALIGN_LEFT, ALIGN_RIGHT,
    WALL_DIRECTION_PARALLEL,
    WALL_DIRECTION_PERPENDICULAR
} from '../../../../../../../common-code/constants';
import {ThreeBottomUnitBarCounter} from '../../../units/ThreeBottomUnit/types/ThreeBottomUnitBarCounter';

export class ThreeBarCounterCorpus extends ThreeCorpus {
    unit: ThreeBottomUnitBarCounter;
    saveData: ISaveBarCounterCorpusData;

    constructor(options: ISaveBarCounterCorpusData, unit: ThreeBottomUnitBarCounter) {
        super(options, unit);
        this.unit = unit;
        this.saveData = options;
    }

    public getFrameLegWidth(): number {
        return this.saveData.frameLegWidth;
    }
    public getFrameLegHeight(): number {
        return this.saveData.frameLegHeight;
    }

    public getFrameMaterialId(): string | undefined {
        return this.saveData.frameMaterial;
    }

    protected addCoverPointsToUnit() {
        let coverPoints: Vector3[];

        switch (this.unit.getWallDirection()) {
            case WALL_DIRECTION_PARALLEL:
                coverPoints = [
                    new Vector3(
                        -this.getWidth() / 2,
                        -this.getHeight() / 2,
                        -this.getDepth() / 2
                    ),
                    new Vector3(
                        this.getWidth() / 2,
                        this.getHeight() / 2,
                        this.getDepth() / 2
                    ),
                ];
                break;
            case WALL_DIRECTION_PERPENDICULAR:
            default:
                coverPoints = [
                    new Vector3(
                        -this.getDepth() / 2,
                        -this.getHeight() / 2,
                        -this.getWidth() / 2
                    ),
                    new Vector3(
                        this.getDepth() / 2,
                        this.getHeight() / 2,
                        this.getWidth() / 2
                    ),
                ];
                break;
        }

        this.unit.addCoverPoints(coverPoints);
        this.addCoverPoints(coverPoints);
    }

    protected createPanels() {
    }

    protected createBackPanels() {
    }

    protected createOtherDetails() {
        this.createLeg();
    }

    protected createLeg() {
        const legModelId: string | undefined = this.unit.getLegModelId();
        if (legModelId !== undefined) {
            this.loadLegModel(legModelId);
        } else {
            this.createDefaultLeg()
        }
    }

    protected loadLegModel(legModelId: string) {
        this.service.loadThreeModel(this, legModelId);
    }

    public setLoadModel(_type: string, details: Object3D[]) {
        let detail: Object3D;
        let newDetail: Object3D;
        let threeLeg: Group;

        threeLeg = new Group();
        for (detail of details) {
            newDetail = detail.clone();
            threeLeg.add(newDetail);
        }
        threeLeg.traverse(child => {
            child.matrixAutoUpdate = false;
        });
        threeLeg.matrixAutoUpdate = false;
        threeLeg.name = 'leg';
        threeLeg.position.copy(this.getLegPosition());
        if (this.unit.getWallDirection() === WALL_DIRECTION_PARALLEL) {
            threeLeg.rotation.y = Math.PI/2;
        }
        this.view3d.add(threeLeg);
        this.updateAllMatrices();
        this.updateViewType();
    }

    protected getLegPosition(): Vector3 {
        let position: Vector3;

        position = new Vector3(0, 0, 0);
        switch (this.unit.getLegPosition()) {
            case ALIGN_RIGHT:
                switch (this.unit.getWallDirection()) {
                    case WALL_DIRECTION_PARALLEL:
                        position.set(
                            (this.unit.getWidth() / 2 - 300) > 0 ? (this.unit.getWidth() / 2 - 300) : 0,
                            0,
                            0
                        );
                        break;
                    case WALL_DIRECTION_PERPENDICULAR:
                    default:
                        position.set(
                            0,
                            0,
                            (-this.unit.getWidth()/2 + 300) < 0 ? (-this.unit.getWidth()/2 + 300) : 0
                        );
                        break;
                }
                break;
            case ALIGN_LEFT:
            default:
                switch (this.unit.getWallDirection()) {
                    case WALL_DIRECTION_PARALLEL:
                        position.set(
                            (-this.unit.getWidth() / 2 + 300) < 0 ? (-this.unit.getWidth() / 2 + 300) : 0,
                            0,
                            0
                        );
                        break;
                    case WALL_DIRECTION_PERPENDICULAR:
                    default:
                        position.set(
                            0,
                            0,
                            (this.unit.getWidth()/2 - 300) > 0 ? (this.unit.getWidth()/2 - 300) : 0
                        );
                        break;
                }
                break;
        }

        return position;
    }

    protected createDefaultLeg() {
        let leg: Mesh;

        leg = new Mesh(
            new CylinderGeometry(20, 20, this.getHeight(), 50, 1),
            this.getBodyMaterial()
        );
        leg.matrixAutoUpdate = false;
        leg.name = 'leg';
        leg.position.copy(this.getLegPosition());
        if (this.unit.getWallDirection() === WALL_DIRECTION_PARALLEL) {
            leg.rotation.y = Math.PI/2;
        }
        this.view3d.add(leg);
    }
}